import React, { memo, useCallback, useContext, useEffect, useState } from 'react';
import { StrategyApyRisks } from '../../../../context/app/appTypes';
import useIsMounted from '../../../../hooks/useIsMounted';
import { CollapsibleAreaContext } from '../../../CollapsibleArea';
import { TabsContext } from '../../../Tabs';
import CapitalAllocation from './CapitalAllocation';

type Props = {
    strategyAllocationDetails: StrategyApyRisks | undefined;
};

const CapitalAllocationDetails: React.FC<Props> = ({ strategyAllocationDetails }) => {
    const { updateCollapsedHeight } = useContext(CollapsibleAreaContext);
    const { updateHeight } = useContext(TabsContext);

    const [collapsed, setCollapsed] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const isMounted = useIsMounted();

    const toggleMoreDetails = useCallback(() => {
        if (disabled) return;

        setDisabled(true);
        setCollapsed((prev) => !prev);
    }, [disabled]);

    useEffect(() => {
        if (!disabled) return;

        updateHeight();

        const interval = setInterval(() => {
            if (isMounted()) {
                updateCollapsedHeight();
            }
        }, 100);

        const timeout = setTimeout(() => {
            clearInterval(interval);
            isMounted() && setDisabled(false);
        }, 600);

        return () => {
            clearInterval(interval);
            clearTimeout(timeout);
        };
    }, [
        disabled,
        collapsed,
        updateHeight,
        updateCollapsedHeight,
        isMounted,
        setDisabled,
    ]);

    return (
        <div className='more-details-container'>
            <div
                className={`more-details-trigger ${collapsed ? 'collapsed' : ''}`}
                onClick={toggleMoreDetails}
            >
                <div className='arrow-container'>
                    <div className='arrow' />
                </div>
                <span>{collapsed ? 'Hide' : 'Show'} Capital Allocation Details</span>
                <div className='line' />
            </div>
            {strategyAllocationDetails && (
                <CapitalAllocation
                    strategyAllocationDetails={strategyAllocationDetails}
                    collapsed={collapsed}
                />
            )}
        </div>
    );
};

export default memo(CapitalAllocationDetails);
